import React from 'react';
import Loadable from 'react-loadable';

import { ConnectedRouter } from 'connected-react-router'
import { Switch, Route, Redirect } from 'react-router-dom';

import PrivateRoute from 'src/components/private-route';
import { RouteLoader } from 'src/components/loader';

/**
 * HoC import.
 */
import VoipHoc from 'components/voip-hoc-wrapper';

/**
 * Modules import.
 */
import AdminRoutes from './adminRoutes';

/**
 * Lazy modules import.
 */
const Auth = Loadable({
    loader: () => import('src/modules/auth'),
    loading: () => <RouteLoader />,
});

const Operators = Loadable({
    loader: () => import('src/modules/operators'),
    loading: () => <RouteLoader />,
});

const Importer = Loadable({
    loader: () => import('src/modules/importer'),
    loading: () => <RouteLoader />,
});

const DebtorArea = Loadable({
    loader: () => import('src/modules/debtor-area'),
    loading: () => <RouteLoader />,
});

const SurveyApply = Loadable({
    loader: () => import('src/modules/surveys/screens/survey-apply'),
    loading: () => <RouteLoader />
});

/**
 * Top level app routes.
 */
export const AppRoutes = ({ history }) => {
    return (
        <ConnectedRouter history={history}>
            <Switch>
                {/* Public Routes */}
                <Route path="/auth">
                    <Auth />
                </Route>                
                {/* <Route path="/operador"> */}
                {/*     <VoipHoc> */}
                {/*         <Operators /> */}
                {/*     </VoipHoc> */}
                {/* </Route> */}
                <Route 
                    path="/operador" 
                    component={() => {
                        window.location.href = 'https://crm.monest.com.br';
                        return null;
                    }}
                />
                <Route path="/divida">
                    <DebtorArea />
                </Route>
                <Route path="/pesquisa/:token">
                    <SurveyApply />
                </Route>

                {/* Private Routes */}
                <PrivateRoute path="/admin" component={AdminRoutes} />
                <PrivateRoute path="/importer" component={Importer} />

                {/* Router Fallback */}
                <Route render={() => <Redirect to='/auth' />} />
            </Switch>
        </ConnectedRouter>
    );
};

export default AppRoutes;
